<template>
  <div>
    <div class="banner"></div>
    <div class="main">
      <div class="main-head">
        <img class="corner"
             :src="corner">
        <div class="head-info clearfix">
          <img class="head-img"
               :src="headimg"
               alt="头像">
          <div class="head-name">
            <h5>{{name}}</h5>
            <p>
              身份证:
              <span>{{cardnum}}</span>
            </p>
          </div>
        </div>
        <hr>
        <div class="head-main">
          <div class="form-cell wx-box">
            <label class="form-label form-wechat"
                   :style="{'background-image':'url(' + icons + ')'}">微信</label>
            <div class="form-box">
              <div class="input-wrap">
                <Input v-model="p_wechat"
                       placeholder=""
                       style="width: 400px;" disabled>
                <img class="form-icon"
                     src="../assets/images/personal/icon_wechat.png"
                     slot="suffix" />
                </Input>
              </div>
            </div>

            <a class="form-update"
               @click="closeWechat"
               v-show="p_wechat"
               href="javascript:;">解绑</a>
            <span style="font-size: 12px;color: #9B9898;" v-show="p_wechat"
                  class="span-right">点击“解绑”解除绑定</span>

            <a class="form-update"
               @click="bindWechat"
               v-show="!p_wechat"
               href="javascript:;">绑定</a>
            <span style="font-size: 12px;color: #9B9898;" v-show="!p_wechat"
                  class="span-right">点击“绑定”扫码绑定微信</span>

          </div>
          <div class="form-cell">
            <label class="form-label form-phone"
                   :style="{'background-image':'url(' + icons + ')'}">手机号</label>
            <!-- <Input v-model="p_phone" placeholder="" style="width: 400px;margin-right: 10px;" /> -->
            <div class="form-box code-box">
              <div class="input-wrap">
                <Input class="inputs"
                       type="text"
                       placeholder="请输入您的手机号"
                       v-model="p_phone"
                       @on-keyup="typingNumber"
                       style="width:260px;">
                </Input>
                <Button class="codeBtn"
                        :class="codes.disabled ? '' : ''"
                        type="default"
                        @click="getCode"
                        :disabled="codes.disabled">{{btnText}}</Button>
              </div>
              <div class="input-wrap" style="margin-top: 15px;">
                <Input class="inputs"
                       type="text"
                       placeholder="请输入验证码"
                       v-model="phoneCode"
                       style="width:400px;"></Input>
              </div>
            </div>
            <a class="form-update"
               href="javascript:;"
               @click="updatePhone">修改</a>
            <span style="font-size: 12px;color: #9B9898;"
                  class="span-right">① 输入新手机号 ② 获取验证码<br /> ③ 点击修改</span>
          </div>
          <div class="form-cell">
            <label class="form-label form-email"
                   :style="{'background-image':'url(' + icons + ')'}">E-mail</label>
            <div class="form-box">
              <div class="input-wrap">
                <Input v-model="p_email"
                       placeholder="请输入您的邮箱"
                       style="width: 400px;filter: none !important;" />
              </div>
            </div>
            <a class="form-update"
               href="javascript:;"
               @click="updateEmail">修改</a>
            <span style="font-size: 12px;color: #9B9898;"
                  class="span-right">输入新邮箱，点击修改</span>
          </div>
          <div class="form-cell">
            <label class="form-label form-password"
                   :style="{'background-image':'url(' + icons + ')'}">密码</label>
            <div class="form-box">
              <!--<div class="input-wrap">
                <Input class="inputs"
                       v-model="p_old_pass"
                       type="password"
                       placeholder="请输入旧密码"
                       style="width: 400px;" />
              </div>-->
              <div class="input-wrap">
                <Input class="inputs"
                       v-model="p_new_pass"
                       type="password"
                       :maxlength="12"
                       placeholder="请输入新密码"
                       style="width: 400px;filter: none !important;" />
              </div>
              <div class="input-wrap" style="margin-top: 15px;">
                <Input class="inputs"
                       v-model="p_con_pass"
                       type="password"
                       :maxlength="12"
                       placeholder="请确认新密码"
                       style="width: 400px;filter: none !important;" />
              </div>
            </div>
            <a class="form-update"
               href="javascript:;"
               @click="updatePassword">修改</a>
            <span style="font-size: 12px;color: #9B9898;"
                  class="span-right">请输入6位以上字母和<br />数字的混合密码</span>
          </div>

        </div>

      </div>
      <div class="main-body"></div>
    </div>
  </div>
</template>
<script>
import corner from "@/assets/images/personal/corner.png";
import headimg from "@/assets/images/personal/head.png";
import icons from "@/assets/images/personal/icon.png";
import * as apis from '@/api/login';
import * as api from '@/api/person';
import { verifyPhone, verifyEmail, verifyPassword } from "../../public/js/util.js";
import { setInterval, clearInterval } from 'timers';
import { getLocalStorage } from '@/utils/tools.js'
export default {
  data () {
    return {
      corner: corner,
      headimg: headimg,
      icons: icons,
      name: '',
      cardnum: '',
      p_wechat: '',
      p_phone: '',
      p_email: '',
      // p_old_pass: '',
      p_new_pass: '',
      p_con_pass: '',
      btnText: '获取验证码',
      codes: {
        disabled: true,
        time: 10,
        timer: null,
      },
      phoneCode: '',
      closeBind: false
    };
  },
  computed: {
    sendCode () {
      if (!this.codes.disabled) {
        return this.countBackwordNumber(this.codes);
      } else {
        return this.codes;
      }
    }
  },
  async mounted () {
    let token = getLocalStorage('token');
    let res = await apis.getUserInfoData({ token });
    this.p_wechat = res.data.nickName;
    this.p_phone = res.data.phone;
    this.p_email = res.data.email;
    this.name = res.data.name || '用户';
    this.cardnum = res.data.id_number;
    localStorage.setItem("username", this.name || '');

    //通过微信返回的code再获取基础信息
    let query = this.$route.query;
    if (Object.keys(query).length > 0) {
      this.sendCodeToLogin(query.code, query.state);
    }
  },
  methods: {
    os() {
      var regex_match = /(nokia|iphone|android|motorola|^mot-|softbank|foma|docomo|kddi|up.browser|up.link|htc|dopod|blazer|netfront|helio|hosin|huawei|novarra|CoolPad|webos|techfaith|palmsource|blackberry|alcatel|amoi|ktouch|nexian|samsung|^sam-|s[cg]h|^lge|ericsson|philips|sagem|wellcom|bunjalloo|maui|symbian|smartphone|midp|wap|phone|windows ce|iemobile|^spice|^bird|^zte-|longcos|pantech|gionee|^sie-|portalmmm|jigs browser|hiptop|^benq|haier|^lct|operas*mobi|opera*mini|320x320|240x320|176x220)/i;
      var u = navigator.userAgent;
      if (null == u) {
        return true;
      }
      var result = regex_match.exec(u);

      if (null == result) {
        return false
      } else {
        return true
      }
    },
    async sendCodeToLogin (code, state) {
      let data = {
        code,
        state
      };
      let res = await apis.sendCodeToBind(data);
      if (res.code == 111) {
        this.$Message("该微信号已被注册过！");
        return;
      }
      if (res.code == 200) {
        this.p_wechat = res.data.nickName;
        let token = res.data.token;
        getLocalStorage("token", token)
        setLocalStorage("loginState", true);
        localStorage.setItem("time", new Date().getTime());
        this.$store.commit("LOGIN_STATE", true);
        this.getLoginOnPersonInfo(token);
      } else {
        this.$Message(res.data.msg[0]);
      }
    },
    async closeWechat() {
      // 调取消绑定接口
      let token = getLocalStorage('token');
      let res = await api.closeWechatApi({ token });
      if (res.code == 200) {
        this.p_wechat = '';
        this.$Message('解绑成功！');
      } else {
        this.$Message(res.data.msg[0]);
      }
    },
    bindWechat () {
      let temp = { ...this.info };
      localStorage.setItem('temp', JSON.stringify(temp));
      let redirect_uri = encodeURIComponent("http://weimajie.com.cn/personal");
      window.location.replace(
        "https://open.weixin.qq.com/connect/qrconnect?appid=wx6842a7f406c7d13f&redirect_uri=" +
        redirect_uri +
        "&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
      );
      // let str =
      //   "https://open.weixin.qq.com/connect/qrconnect?appid=wx6842a7f406c7d13f&redirect_uri=" +
      //   redirect_uri +
      //   "&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect&uid=" + this.uid;

      // var obj = new WxLogin({
      //   id: "qrCode",
      //   appid: "wx6842a7f406c7d13f",
      //   scope: "snsapi_login",
      //   redirect_uri: "",
      //   href: "",
      //   state: ""
      // });
    },
    async updatePassword () {
      // if (this.p_old_pass == "") {
      //   this.$Message('请输入旧密码！');
      //   return false;
      // }
      let flag = verifyPassword(this.p_new_pass);
      if (!flag) {
        this.$Message.error('密码应为6-12位字母和数字组成！');
        return false;
      }
      if (this.p_new_pass != this.p_con_pass) {
        this.$Message.error('新密码和确认密码不一致！');
        return false;
      }
      try {
        let data = {
          // old_password: this.p_old_pass,
          password: this.p_new_pass,
          confirm_password: this.p_con_pass
        };
        let res = await api.updateUserPwd(data);
        if (res.code == 200) {
          this.$Message.success('修改密码成功！');
        } else {
          this.$Message.error(res.data.msg[0]);
        }
      } catch (e) {
        console.log(e);
      }
    },
    async updatePhone () {
      if (this.phoneCode == "") {
        this.$Message.error('请输入手机验证码！');
        return false;
      }
      try {
        let data = {
          phone: this.p_phone,
          code: this.phoneCode
        }
        let res = await api.updatePhoneNumber(data);
        if (res.code == 200) {
          this.$Message.success('修改手机号成功！');
          location.reload();
        } else {
          this.$Message.error('修改手机号失败！');
        }
      } catch (e) {
        console.log(e)
      }
    },
    async updateEmail () {
      if (!verifyEmail(this.p_email)) {
        this.$Message.error('邮箱格式不正确！');
        return false;
      }
      try {
        let data = {
          email: this.p_email
        };
        let res = await api.updateUserEmail(data);
        if (res.code == 200) {
          this.$Message.success('修改邮箱成功！');
        } else {
          this.$Message.error('修改邮箱失败！');
        }
      } catch (e) {
        console.log(e);
      }
    },
    countBackwordNumber (obj) {
      const TIME_COUNT = 10;
      if (!obj.timer) {
        obj.time = TIME_COUNT;
        obj.disabled = false;
        obj.timer = setInterval(() => {
          if (obj.time > 0 && obj.time <= TIME_COUNT) {
            obj.time--;
            this.btnText = obj.time + 's后重新获取';
            obj.disabled = true;
          } else {
            obj.disabled = false;
            clearInterval(obj.timer);
            this.btnText = '获取验证码';
            obj.timer = null;
          }
        }, 1000);
      }
      return {
        timer: obj.timer,
        disabled: obj.disabled,
        time: obj.time
      }
    },
    async getCode () {

      let phone = this.p_phone;
      let flag = verifyPhone(phone);
      if (!flag) {
        this.$Message.error('手机号格式不正确！');
        return false;
      }
      this.countBackwordNumber(this.codes);
      let data = {
        phone: phone
      };
      let res = await api.getPhoneCode(data);
      if (res.code == 200) {
        this.$Message.success({
          content: res.data.mobile[0],
          duration: 3
        });
      } else {
        this.$Message.error({
          content: res.data.phone[0],
          duration: 3
        });
      }
    },
    typingNumber () {  //输入手机号
      let phone = this.p_phone;
      let flag = verifyPhone(phone);
      console.log(flag)
      if (flag) {
        this.codes.disabled = false
      } else {
        this.codes.disabled = true
      }
    }
  }
};
</script>
<style lang="less" scoped>
.input-wrap {
  display: inline-block;
  border: 2px solid #ddd;
  border-radius: 4px;
}
.form-box {
  display: inline-block;
  width: 400px;
  margin-right: 10px;
  vertical-align: top;
}
.code-box {
  position: relative;
}
.codeBtn {
  position: absolute !important;
  top: 0px !important;
  right: 0px !important;
  width: 140px;
  height: 44px !important;
  background: #ac4126;
  color: #fff;
  font-size: 14px;
  border: none !important;
  vertical-align: top;
  // border-top-left-radius: 0;
  // border-bottom-left-radius: 0;
  border-left: 2px solid #ddd !important;
}
.codeBtn:disabled {
  border: 2px solid #ddd !important;
}
.codeBtn:hover {
  background-color: #ac4126;
  color: #fff;
}
.banner {
  width: 100%;
  height: 250px;
  background: url('../assets/images/personal/banner.jpg') no-repeat center;
}
.main {
  width: 980px;
  background: #fff;
  border-radius: 8px;
  margin: 45px auto 88px;
  .main-head {
    position: relative;
    height: auto;
    padding: 0 18px 30px;
    .corner {
      position: absolute;
      left: 0;
      top: 0;
      background: #f4f4f4;
    }
  }
}
.head-info {
  width: 564px;
  padding: 30px 0;
  margin: 0 auto;
}
.head-img {
  float: left;
  width: 70px;
  height: 70px;
  margin-right: 24px;
}
.head-name {
  h5 {
    font-size: 30px;
    color: #b53326;
    line-height: 50px;
  }
  p {
    font-size: 18px;
    color: #333130;
    line-height: 24px;
    span {
      font-size: 22px;
    }
  }
}
.head-main {
  width: 832px;
  margin: 30px auto;
}
.form-cell {
  margin: 0;
  margin-bottom: 26px;
}
.form-label {
  display: inline-block;
  width: 130px;
  font-size: 20px;
  color: #333130;
  line-height: 50px;
  background-repeat: no-repeat;
  background-size: 24px auto;
  vertical-align: top;
  padding-left: 30px;
}
.form-wechat {
  background-position: 0 15px;
}
.form-phone {
  background-position: 0 -32px;
}
.form-email {
  background-position: 0 -78px;
}
.form-password {
  background-position: 0 -124px;
}
.wx-box {
  position: relative;
}
.form-icon {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 60px;
  height: 44px;
  background: #85bf76;
  box-sizing: border-box;
  border-top-right-radius: 4px;
  cursor: pointer;
  border-bottom-right-radius: 4px;
  padding: 8px 14px;
}

.ivu-input-with-suffix {
  padding-right: 72px;
}
.form-update {
  font-size: 20px;
  color: #b53326;
  line-height: 50px;
}
.span-right {
  // float: right;
  margin-left: 16px;
}
</style>
<style>
.ivu-input-wrapper .ivu-input-suffix {
  width: 60px;
  right: 0;
}
</style>

